import React, { useState, useMemo } from "react"
import { Box, Button, Container, Grid, Typography } from "@mui/material"
import { data, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { DEVICE, DEVICEDATA } from "../../services/actions";
import { MdBatteryChargingFull, MdBolt, MdOutlineSolarPower, MdCamera, MdAddAlert } from "react-icons/md";
import DeviceCard from './DeviceCard'
import Gauge from "./Gauge";

const MainCard = ({ icon, title = "Test", label = "", value = 0, bgColor = "green" }) => {
    return <div className="shadow" style={{ padding: 20, borderRadius: 24 }}>
        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
            <div style={{ minWidth: 30 }}>
                {icon}
            </div>
            <div className="input-label" style={{ width: '100%', fontSize: 16, fontWeight: 800 }}>
                <h4>{title}</h4>
            </div>
        </div>
        <div className="battery-row" style={{ paddingLeft: 20, paddingRight: 20 }}>
            <strong className="input-label">{value || 0}%</strong>
            <div className="progress">
                <div
                    className="progress-bar"
                    style={{
                        width: `${value || 0}%`,
                        backgroundColor: bgColor,
                    }}
                />
            </div>
        </div>
    </div>
}

const Devices = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const deviceState = useSelector((state) => state?.deviceState);
    const devicedataState = useSelector((state) => state?.devicedataState);
    const fetchDevices = (force) => {
        if (force) {
            dispatch({ type: `${DEVICE}_GET`, payload: 'solar/equipment-list?force_refresh=true' });
        } else {
            dispatch({ type: `${DEVICE}_GET`, payload: 'solar/equipment-list' });
        }
        dispatch({ type: `${DEVICEDATA}_GET`, payload: `solar/device-history/` });
    }
    // const fetchDevicesData = (deviceId = 0) => {
    //     // dispatch({ type: `${DEVICEDATA}_GET`, payload: `solar/device-history/?device_id=${deviceId}` });
    //     dispatch({ type: `${DEVICEDATA}_GET`, payload: `solar/device-history/` });
    // }
    // // Reload companies when one is added or edited
    // React.useEffect(() => {
    //     // fetchDevices(false)
    //     fetchDevicesData()
    // }, [dispatch]);
    React.useEffect(() => {
        const fetchDevicesData = (deviceId = 0) => {
            dispatch({
                type: `${DEVICEDATA}_GET`,
                payload: `solar/device-history/`
            });
        };

        // initial call
        fetchDevicesData();

        // 10 minutes = 600000 ms
        const interval = setInterval(() => {
            fetchDevicesData();
        }, 600000);

        // cleanup to prevent memory leaks
        return () => clearInterval(interval);
    }, [dispatch]);


    const formatData = (data) => {
        return data.map((item) => {
            const firstDevice = item.history?.list?.[0];
            const firstValue = firstDevice?.list?.[0];
            return {
                name: item.name,
                value: firstValue?.value || null,
                time: firstValue?.time || null,
            };
        });
    }
    const calculateAverages = (items) => {
        let solarTotal = 0;
        let batteryTotal = 0;
        let countSolar = 0;
        let countBattery = 0;
        let countOnline = 0;
        let countWarning = 0;

        items?.forEach((device) => {
            const solarObj = device.solar?.find(d => d.name?.toLowerCase().includes("pv voltage"));
            const batteryObj = device.battery?.find(d => d.name?.toLowerCase().includes("soc"));

            const solarPower = parseFloat(solarObj?.value);
            const batteryPower = parseFloat(batteryObj?.value);

            const status = device.status;

            if (status === "online" || status === "warning") {
                countOnline++;
            }
            if (status === "warning") {
                countWarning++;
            }

            if (!isNaN(solarPower)) {
                solarTotal += solarPower;
                countSolar++;
            }

            if (!isNaN(batteryPower)) {
                batteryTotal += batteryPower;
                countBattery++;
            }
        });

        const totalDevices = items?.length || 0;

        return {
            avgSolarPower: countSolar ? (solarTotal / countSolar).toFixed(2) : 0,
            avgBatteryPower: countBattery ? (batteryTotal / countBattery).toFixed(2) : 0,
            avgCamera: totalDevices ? ((countOnline / totalDevices) * 100).toFixed(0) : 0,
            avgAlerts: totalDevices ? ((countWarning / totalDevices) * 100).toFixed(0) : 0,
        };
    };

    const enrichedDevices = useMemo(() => {
        return devicedataState?.data?.map((d) => {
            const solar = formatData(d.pv_information);
            const battery = formatData(d.battery_information);
            const load = formatData(d.load_information);
            let status = solar?.[0]?.value == null ? "offline" : "online"
            if (status == "online") {
                const soc = battery?.filter((d) => d.name == "Battery SOC")
                status = soc?.[0]?.value < 50 ? "warning" : status
            }
            return {
                ...d,
                solar,
                battery,
                load,
                status
            };
        });
    }, [devicedataState]);

    const devices = devicedataState?.data || [];

    const { avgSolarPower, avgBatteryPower, avgCamera, avgAlerts } = useMemo(() => {
        return calculateAverages(enrichedDevices);
    }, [enrichedDevices]);

    return (<>
        <Container maxWidth="false" >
            <Grid container spacing={1} sx={{ pb: 2 }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12, xxl: 12 }}>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Box></Box><Button onClick={() => fetchDevices(true)}>Refresh</Button>

                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                    {/* <MainCard
                        icon={<MdBatteryChargingFull style={{ fontSize: 30, color: 'green' }} />}
                        title={"Average Battery"}
                        value={avgBatteryPower}
                    /> */}

                    <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Gauge label="Solar" value={avgSolarPower} icon={<MdOutlineSolarPower style={{ color: '#0088ff', fontSize: 24 }} />} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                    {/* <MainCard
                        icon={<MdOutlineSolarPower style={{ fontSize: 30, color: 'green' }} />}
                        title={"Average Solar"}
                        value={avgSolarPower}
                    /> */}
                    <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Gauge label="Battery" value={avgBatteryPower} icon={<MdBatteryChargingFull style={{ color: '#22c55e', fontSize: 24 }} />} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                    {/* <MainCard
                        icon={<MdCamera style={{ fontSize: 30, color: 'green' }} />}
                        title={"Camera Online"}
                        value={avgCamera}
                    /> */}
                    <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Gauge label="Camera" status="Online" value={"24/28"} latString="" icon={<MdCamera style={{ color: '#a855f7', fontSize: 24 }} />} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                    {/* <MainCard
                        icon={<MdAddAlert style={{ fontSize: 30, color: 'green' }} />}
                        title={"Alerts"}
                    /> */}
                    <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Gauge label="Alerts" status="Alert" value={avgAlerts} latString="" icon={<MdAddAlert style={{ color: '#ef4444', fontSize: 24 }} />} />
                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="stretch">
                {(enrichedDevices || []).map((d) => (
                    <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }} key={d.device_id || d.device_name}>
                        <DeviceCard
                            deviceId={d.device_id}
                            title={d.device_name}
                            initialMapping={d.camera_mapping}
                            solarData={d.solar}
                            batteryData={d.battery}
                            loadData={d.load}
                            avgPvPower={d.pvPowerAvg}
                            status={d.status}
                        />
                    </Grid>
                ))}
            </Grid>
            {devicedataState?.data?.length == 0 && <>No data found</>}
        </Container>
    </>
    )
}

export default Devices